<template>
  <Layout>
    <router-view :key="$route.fullPath"></router-view>
  </Layout>
</template>

<script>
import { mapActions } from 'vuex';
import { SET_IS_PRINTING } from './store/mutations';
import Layout from './components/Layout';
import { INIT, FETCH_CLIENTS } from './store/actions';

export default {
  name: 'App',
  components: {
    Layout,
  },
  data() {
    return {
      mediaQuery: null,
    };
  },
  computed: {
    isPrinting: {
      get() {
        return this.$store.state.isPrinting;
      },
      set(value) {
        this.$store.commit(SET_IS_PRINTING, value);
      },
    },
  },
  async created() {
    await this.INIT();
    if (this.$can('getAll', 'clients')) {
      this.FETCH_CLIENTS();
    }
  },
  mounted() {
    this.mediaQuery = window.matchMedia('print');
    this.mediaQuery.addEventListener('change', this.handlePrintChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeEventListener('change', this.handlePrintChange);
  },
  methods: {
    ...mapActions([INIT, FETCH_CLIENTS]),
    handlePrintChange(e) {
      this.isPrinting = e.matches;
    },
  },
};
</script>

<style lang="scss">
.header-nowrap .v-data-table-header th {
  white-space: nowrap;
}

.no-wrap {
  white-space: nowrap;
}
/*
The .date-picker-custom and .date-picker-custom-criteria classes added here because
class .v-text-field re-determines it in the target components
 */
.date-picker-custom {
  .v-input__prepend-inner {
    padding-right: 0 !important;
  }
  .v-text-field__slot {
    .v-label {
      left: 4px !important;
    }
    input {
      padding-left: 4px !important;
    }
  }
}
.date-picker-custom-criteria {
  .v-text-field__slot {
    .v-label--active {
      left: -24px !important;
    }
  }
}
.dialog-v-text-scrollable {
  max-height: calc(100vh - 215px);
  max-height: calc(100dvh - 215px);
  overflow-y: scroll
}
</style>
